import React, { useRef } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import GalleryCarousel from './components/GalleryCarousel';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import ContactFormWithFiles from './components/ContactFormWithFiles';
import Footer from './components/Footer';

function App() {
  const galleryRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToGallery = () => {
    galleryRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Header />
      <Hero onGetQuote={scrollToContact} onSeeWork={scrollToGallery} />
      <div ref={galleryRef}>
        <Services />
      </div>
      <GalleryCarousel />
      <HowItWorks />
      <Pricing />
      <div ref={contactRef}>
        <ContactFormWithFiles />
      </div>
      <Footer />
    </div>
  );
}

export default App;
